/**
 * Created by Ivan on 21.06.2026
 */

cleverapps.override(cleverapps.EVENTS, {
    LORYS_DERBY: {
        EARN: "lorys_derby",
        STAGE: "lorys_derby_stage_"
    }
});
